import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { capitalizeFirst } from "../config/grid-value-formatters";

export default function RoleBasedNavigator ({ allowedRoles, params }) {
    const { data: user } = useSelector(state => state.user);

    let show = allowedRoles.some(r => r === user.roles);

    return show ? (
        <Link to={`${params?.data?.id}`} state={params?.data}>{capitalizeFirst(params)}</Link> 
    ) : (
        <>{params.value}</>
    )
}